import { render, staticRenderFns } from "./Xiezuoupload.vue?vue&type=template&id=2e581872&"
import script from "./Xiezuoupload.vue?vue&type=script&lang=js&"
export * from "./Xiezuoupload.vue?vue&type=script&lang=js&"
import style0 from "./Xiezuoupload.vue?vue&type=style&index=0&id=2e581872&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports